import type { ClientError } from 'graphql-request'

export function is401Error(err: unknown): boolean {
    if (!err || typeof err !== 'object') return false
    const e = err as ClientError
    if (e.response?.status === 401 || e.response?.status === 403) return true
    const errors = e.response?.errors ?? []
    return errors.some(
        (er: { extensions?: { code?: string } }) =>
            er?.extensions?.code === 'UNAUTHENTICATED' || er?.extensions?.code === 'PERMISSION_DENIED'
    )
}

export function getErrorMessage(err: unknown): string {
    if (!err) return 'Neznámá chyba'
    if (err instanceof Error) {
        const e = err as ClientError
        const first = e.response?.errors?.[0]
        if (first?.message) return first.message
        return err.message
    }
    return String(err)
}
